import { css } from '@emotion/react'
import { Heading, HFlow, Text, VFlow } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import { AcompanhamentoCondicaoSaudeTematicaEnum } from 'graphql/types.generated'
import { useState } from 'react'
import { Meta } from 'util/metaPath'

import { listaTematicaEntries } from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'
import { ListaTematicaInformacaoModal } from './ListaTematicaInformacaoModal'
import { ListaTematicaInformacaoModalLegacy } from './ListaTematicaInformacaoModalLegacy'
import { ListaTematicaRadioButton } from './ListaTematicaRadioButton'

interface ListaTematicaSectionProps {
  name: Meta<AcompanhamentoCondicaoSaudeTematicaEnum>
  handleChangeListaTematica: (listaTematica: AcompanhamentoCondicaoSaudeTematicaEnum) => void
}

export const ListaTematicaSection = (props: ListaTematicaSectionProps) => {
  const { name, handleChangeListaTematica } = props

  const { ACOMPANHAMENTO_CONDICAO_SAUDE_MARTS_ENABLED } = useFlags()

  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <VFlow vSpacing={0.5}>
      <HFlow hSpacing={0.5} alignItems='baseline'>
        <Heading level={2}>Listas Temáticas</Heading>
        <Text style={{ cursor: 'pointer' }} variant='link' fontWeight='bold' onClick={() => setIsModalOpen(true)}>
          Saiba mais
        </Text>
        {isModalOpen &&
          (ACOMPANHAMENTO_CONDICAO_SAUDE_MARTS_ENABLED ? (
            <ListaTematicaInformacaoModal isModalOpen setIsModalOpen={setIsModalOpen} />
          ) : (
            <ListaTematicaInformacaoModalLegacy isModalOpen setIsModalOpen={setIsModalOpen} />
          ))}
      </HFlow>
      <HFlow hSpacing={0.5} style={styles.hFlow}>
        {listaTematicaEntries.map(([tematica, { titulo, icone }]) => (
          <ListaTematicaRadioButton
            key={tematica}
            name={name}
            label={titulo}
            value={tematica}
            onClick={handleChangeListaTematica}
            icon={icone}
          />
        ))}
      </HFlow>
    </VFlow>
  )
}

const styles = {
  hFlow: css`
    display: flex;
    flex-wrap: wrap;
    align-items: start;
  `,
}
